<script setup>
import {computed, useAttrs} from "vue";
import DefaultLabel from "@/components/global-themed/inputs/DefaultLabel.vue";

defineProps({
  validationErrors: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  label: {
    type: [String, null],
    required: false,
    default: null,
  },
  iconPath: {
    type: [String, null],
    required: false,
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  }
});

defineOptions({
  inheritAttrs: false
})

const {class: classAttribute, disabled, ...inputAttributes} = useAttrs();

const isDisabled = computed(() => disabled !== undefined);

const inputValue = defineModel({
  type: [String],
  required: true,
});
</script>

<template>
  <div class="tw-relative tw-w-full">
    <div class="tw-flex tw-flex-col tw-w-full">
      <DefaultLabel
        v-if="label"
        :for="$attrs.id"
        :label="label"
      />
      <div
        v-bind="classAttribute"
        class="tw-flex tw-gap-3 tw-py-3 focus-within:tw-border-primary tw-border-neutral tw-border tw-text-neutral-900 tw-text-base tw-w-full tw-rounded-lg"
        :class="{
          'tw-px-6': !iconPath,
          'tw-px-4': iconPath,
          '!tw-border-danger': validationErrors.length > 0,
          'tw-cursor-not-allowed tw-bg-neutral-300': isDisabled,
        }"
      >
        <div
          v-if="iconPath"
          class="tw-flex tw-justify-center tw-items-center"
        >
          <svg-vue
            :icon="iconPath"
            class="tw-h-6 tw-w-6 tw-text-neutral"
          />
        </div>
        <input
          v-model="inputValue"
          v-bind="inputAttributes"
          class="tw-flex-grow tw-rounded-lg"
          :class="{
            'tw-cursor-not-allowed tw-bg-neutral-300': isDisabled,
          }"
          :disabled="disabled"
          :type="type"
        >
      </div>
    </div>
    <small
      v-for="(error, index) in validationErrors"
      :key="index"
      class="tw-text-danger tw-self-baseline tw-absolute tw-block tw-mt-1"
    >
      {{ error }}
    </small>
  </div>
</template>
